module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/other-amenties-icon-5414428b12e908a577df4d00dc7f42d9.png";